import React ,{useState, useEffect} from "react";
import StudentLayout from "../Layout";
import {
  useGetOrdersByStudentIdQuery,
  useGetStudentByEmailIdQuery,
} from "../../../graphql/generated.tsx";
import {
  FaBox,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaIdBadge,
  FaShoppingCart,
} from "react-icons/fa";
import Loader from "../../../components/Loader.jsx";
const Orders = () => {
  const email = JSON.parse(localStorage.getItem("user")).email;
  const {
    data: StudentData,
    loading: studentLoading,
    error: studentError,
  } = useGetStudentByEmailIdQuery({
    variables: { email },
  });

   const [Isload, setIsload] = useState(true);

   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);

  const {
    data,
    loading: ordersLoading,
    error: ordersError,
  } = useGetOrdersByStudentIdQuery({
    variables: { student_id: StudentData?.getStudentByEmailId?.id },
    skip: !StudentData?.getStudentByEmailId?.id,
  });

  if (studentLoading || ordersLoading || Isload) {
    return (
      <StudentLayout>
        <div className="flex items-center justify-center min-h-screen">
          <Loader />
        </div>
      </StudentLayout>
    );
  }

  if (studentError || ordersError) {
    return (
      <StudentLayout>
        <div className="flex items-center justify-center h-full">
          <p className="text-lg font-medium text-red-500">
            Error loading data. Please try again later.
          </p>
        </div>
      </StudentLayout>
    );
  }

  const orders = data?.getOrdersByStudentId || [];

  return (
    <StudentLayout>
      <div className="relative min-h-screen p-10 m-10 rounded-lg shadow-lg bg-gray-50 max-md:ml-12">
        <div className="flex items-center justify-center mb-10">
          <h1 className="text-5xl font-extrabold tracking-wide text-primary max-md:text-3xl">
            🛒 Your Orders
          </h1>
        </div>
        {orders.length > 0 ? (
          <div className="p-10 space-y-10">
            {orders.map((order, index) => (
              <div
                key={order.order_id}
                className="p-8 bg-white border-l-4 shadow-lg rounded-xl border-primary"
              >
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-2xl font-bold text-primary">
                    Invoice #{index + 1}
                  </h2>
                  <span className="text-sm text-gray-500">
                    <FaCalendarAlt className="inline mr-1" />
                    {new Date(order.payment_date).toLocaleDateString()}
                  </span>
                </div>
                <hr className="mb-5 border-gray-300" />
                <div className="grid grid-cols-4 gap-5">
                  <div className="flex items-center">
                    <FaIdBadge className="mr-3 text-primary" />
                    <div>
                      <span className="block font-semibold">Order ID</span>
                      <span className="text-gray-700">{order.order_id}</span>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <FaBox className="mr-3 text-primary" />
                    <div>
                      <span className="block font-semibold">Course Name</span>
                      <span className="text-gray-700">{order.course_name}</span>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <FaMoneyBillWave className="mr-3 text-primary" />
                    <div>
                      <span className="block font-semibold">Amount Paid</span>
                      <span className="text-green-500">₹{order.amount}</span>
                    </div>
                  </div>
                  {/* <div className="flex items-center">
                    <FaCalendarAlt className="mr-3 text-primary" />
                    <div>
                      <span className="block font-semibold">
                        Date of Purchase
                      </span>
                      <span className="text-gray-700">
                        {new Date(order.payment_date).toLocaleDateString()}
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg font-medium text-center text-gray-600">
            No orders found.
          </p>
        )}
      </div>
    </StudentLayout>
  );
};

export default Orders;
